import { Box, Flex } from 'reflexbox';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormikProvider, useFormik } from 'formik';

import { Route, Switch } from '@treams/treams-routes';

import * as graphql from 'generated/graphql';
import { SectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import HorizontalRule from 'packages/kakapo-ui-kit/components/common/HorizontalRule';
import LearningEventsSlider from 'packages/kakapo-ui-application/pages/learning/components/LearningEventsSlider';
import LearningEventsList from 'packages/kakapo-ui-application/pages/learning/components/LearningEventsList';
import PlainIconNavigationBar from 'packages/kakapo-ui-kit/components/navigation/PlainIconNavigationBar';
import PlainIconNavigationLink from 'packages/kakapo-ui-kit/components/navigation/PlainIconNavigationLink';
import ListViewIcon from 'packages/kakapo-ui-kit/assets/icons/ListViewIcon';
import CalendarIcon from 'packages/kakapo-ui-kit/assets/icons/CalendarIcon';
import LearningFilterSidebar from 'packages/kakapo-ui-application/pages/learning/components/LearningFilterSidebar';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';

export default function LearningEventsContainer() {
	const { t } = useTranslation();

	const formik = useFormik({
		initialValues: {
			types: [],
			subjects: [],
		},
		onSubmit: () => {},
	});

	const [upcomingEventsKey, setUpcomingEventsKey] = useState(Math.random());

	const { data, refetch } = graphql.useLearningEventsQuery({
		variables: {
			first: 100,
			filters: {
				isArchived: false,
				learningTypeIDs: formik.values.types,
				learningSubjectIDs: formik.values.subjects,
			},
		},
	});

	const learningEvents = {
		edges: data?.learningEvents.edges,
	} as graphql.LearningEventConnection;

	learningEvents.edges = learningEvents?.edges?.filter(
		({ node }) => node.isViewerAttending || node.viewerCanJoin,
	);

	return (
		<>
			<Box mb={[4, 4, 5]}>
				<LearningEventsSlider key={upcomingEventsKey} title={t('learning.events.upcoming.title')} />
			</Box>

			<Flex mb={3} justifyContent="space-between" alignItems="center">
				<SectionTitle>{t('learning.events.explore.title')}</SectionTitle>

				<PlainIconNavigationBar
					renderMenuItems={() => (
						<>
							<PlainIconNavigationLink
								icon={<ListViewIcon />}
								link={{
									to: '/learning',
									title: t('learning.events.navigation.listView'),
									isActive: true,
								}}
							/>
							<PlainIconNavigationLink
								icon={<CalendarIcon />}
								link={{
									to: '/learning/calendar',
									title: t('learning.events.navigation.calendarView'),
								}}
							/>
						</>
					)}
				/>
			</Flex>
			<HorizontalRule />

			<Flex mt={4} flexWrap="wrap">
				<Box width={[1, 1, 1 / 3, 1 / 4]} pr={[0, 0, 3, 4]}>
					<FormikProvider value={formik}>
						<LearningFilterSidebar />
					</FormikProvider>
				</Box>

				<Box width={[1, 1, 2 / 3, 3 / 4]}>
					{data ? (
						<LearningEventsList events={learningEvents as graphql.LearningEventConnection} />
					) : (
						<Spinner isLoading size="18px" />
					)}
				</Box>
			</Flex>
		</>
	);
}
